import interactionClickEvents from './interactionClickEvents';

const commonTracking = {
    interaction: interactionClickEvents,
};

export default commonTracking;
